import { sparql } from '@tpluscode/rdf-string';
import { concat } from "../TemplateResult.mjs";
export default (({
  required
}) => ({
  patterns: null,

  whereClause() {
    if (this.patterns) {
      return sparql`WHERE {
${this.patterns}
}`;
    }

    if (required) {
      return sparql`WHERE {}`;
    }

    return sparql``;
  },

  WHERE(strings, ...values) {
    return { ...this,
      patterns: concat(this.patterns, strings, values)
    };
  }

}));